import { API_URL } from '../config';

export const exportToExcel = async (roadId: number, roadName: string) => {
  try {
    const response = await fetch(`${API_URL}/roads/${roadId}/export/excel`);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${roadName}_${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    alert('Erreur lors de l\'export Excel');
  }
};

export const exportToPDF = async (roadId: number, roadName: string) => {
  try {
    const userProfile = localStorage.getItem('userProfile');
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (userProfile) {
      headers['X-User-Profile'] = userProfile;
    }
    
    const response = await fetch(`${API_URL}/roads/${roadId}/export/pdf`, { headers });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `rapport_${roadName}_${new Date().toISOString().split('T')[0]}.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error exporting to PDF:', error);
    alert('Erreur lors de l\'export PDF');
  }
};
